/**
 * The chat list always keeps a visible scroll bar (WF-2606). Narrow panels such as the Workforce
 * Assistant ask for a thin one so a long, expanded tool result still shows the list scrolls without
 * the full-width bar crowding the messages. (WF-2734 QA)
 */
export function chatScrollbarSx(showScrollbar: boolean): { scrollbarWidth?: 'thin' } {
  return showScrollbar ? { scrollbarWidth: 'thin' } : {}
}
